module.exports = __webpack_public_path__ + "img/A-Microbes.ecf9509b.png";